import axiosApiInstance from './request';
const apiVersion = 'v1';
const createStripeAccountService = async (payload: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.post(`/create-stripe-account/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
const stripeFeeCalculationService = async (payload: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.post(`/payment-stripe-fee/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
const stripePaymentCheckoutService = async (payload: any) => {
  let response: any = {};
  try {
    const headers = { 'Content-Type': 'application/json' };
    response = await axiosApiInstance.post(`/payment-checkout/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
export { createStripeAccountService, stripeFeeCalculationService, stripePaymentCheckoutService };
